import turfbezierSpline from '@turf/bezier-spline';
import { lineString as turfLineString } from '@turf/helpers';
import turfMidpoint from '@turf/midpoint';
import turfTransformRotate from '@turf/transform-rotate';
import mapboxgl from 'mapbox-gl';

import { Line, Marker } from './types';

export const getMarkerElement = (type?: Marker['type']) => {
  if (type === 'driver') {
    const el = document.createElement('div');
    el.className = 'driver-marker';
    return el;
  } else if (type === 'start') {
    const el = document.createElement('div');
    el.className = 'departure-marker';
    return el;
  } else if (type === 'end') {
    const el = document.createElement('div');
    el.className = 'arrival-marker';
    return el;
  } else if (type === 'previousDropOff') {
    const el = document.createElement('div');
    el.className = 'drop-off-marker';
    return el;
  }

  return undefined;
};

export const addLineToMap = (line: Line, map: mapboxgl.Map) => {
  map.addSource(line.id, {
    type: 'geojson',
    data: { type: 'Feature', properties: {}, geometry: { type: 'LineString', coordinates: line.coordinates } },
  });
  map.addLayer({
    id: line.id,
    type: 'line',
    source: line.id,
    layout: { 'line-join': 'round', 'line-cap': 'round' },
    paint: { 'line-color': line.color, 'line-width': line.width },
  });
};

export const getCurvedLineCoordinates = (start: [number, number], end: [number, number]): Line['coordinates'] => {
  const line = turfLineString([start, end]);
  const radiusLine = turfTransformRotate(line, 90);
  // Get the ref point to make sure that the arc is always drawn in the right direction
  const radiusLineStart = radiusLine.geometry.coordinates[0];
  const radiusLineEnd = radiusLine.geometry.coordinates[1];
  const radiusLineRefPoint = start <= end ? radiusLineStart : radiusLineEnd;
  // Get the arc center: the highest point in the arc
  const midPoint = turfMidpoint(start, end).geometry.coordinates;
  const arcCenter = turfMidpoint(midPoint, radiusLineRefPoint).geometry.coordinates;
  // Draw the curve
  /* Creating a curved line between two points. */
  const curved = turfbezierSpline(turfLineString([start, arcCenter, end]), {
    sharpness: 1,
  });

  return curved.geometry.coordinates as [number, number][];
};
